import React, { Component } from "react";
import { connect } from "react-redux";
import { Paper } from "@material-ui/core";
import UploadFile from "../uploadFile";
import Signbutton from "../../forms/button";
import { NPS_URL } from "./index";

class onlineEmpanelementupload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Document_details: [],
      PAN: {
        isError: true,
        isShowError: false,
        fileSize: "",
        AED_DocName: "",
        AED_DocType: "PAN",
        AED_DocImage: "",
      },
      CHQ: {
        isError: true,
        isShowError: false,
        fileSize: "",
        AED_DocName: "",
        AED_DocType: "CHQ",
        AED_DocImage: "",
      },
      ADCR: {
        isError: true,
        isShowError: false,
        fileSize: "",
        AED_DocName: "",
        AED_DocType: "ADCR",
        AED_DocImage: "",
      },
      ADPR: {
        isError: true,
        isShowError: false,
        fileSize: "",
        AED_DocName: "",
        AED_DocType: "ADPR",
        AED_DocImage: "",
      },
    };
  }
  submit = () => {
    const { Document_details, ...others } = this.state;
    const keys = Object.keys(others);
    const findError = keys.filter((key) => others[key].isError);
    if (findError.length > 0) {
      findError.forEach((key) => {
        this.setState({
          [key]: {
            isError: true,
            isShowError: true,
            fileSize: "",
            AED_DocName: "",
            AED_DocType: this.state[key].AED_DocType,
            AED_DocImage: "",
            errorMessage:
              key === "PAN"
                ? "PAN is Mandatory*"
                : key === "ADCR"
                ? "ARN Certificate is Mandatory*"
                : key === "CHQ"
                ? "Cancelled Cheque is Mandatory*"
                : key === "ADPR"
                ? "Adress Proof is Mandatory*"
                : "",
          },
        });
      });
    } else {
      this.props.history.push(NPS_URL + "/onlineEmpanelement/summary", {
        ...this.state,
      });
    }
  };

  panUpload = (label) => (e) => {
    if (!!e.target.files.length) {
      const file = e.target.files[0];
      var fileReader = new FileReader();
      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        base64 = fileLoadedEvent.target.result;
        const fileName = file.name;
        if (
          !/^[a-zA-Z0-9-_]+(.{1}(jpe?g|png|pdf|JPE?G|PNG|PDF))$/.test(fileName)
        ) {
          this.setState({
            PAN: {
              name: "",
              isError: true,
              isShowError: true,
              AED_DocImage: "",
              AED_DocType: "PAN",
              errorMessage:
                "Invalid Filename. Filenames may only have A-Z, a-z, 0-9,' - ' and '_' ",
            },
          });
          return;
        }
        const filesize = Math.floor(file.size / 1024);
        if (filesize > 5000 || filesize < 2) {
          alert("File Size should be between 2KB and 5MB.");
          return;
        }
        this.setState({
          PAN: {
            name: file.name,
            isError: false,
            isShowError: false,
            AED_DocImage: base64.split(",")[1],
            AED_DocName: file.name,
            AED_DocType: "PAN",
            fileSize: `(${filesize}Kb)`,
          },
        });
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    }
  };

  AddressCorrespondenceUpload = (label) => (e) => {
    if (!!e.target.files.length) {
      const file = e.target.files[0];
      var fileReader = new FileReader();
      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        base64 = fileLoadedEvent.target.result;
        const fileName = file.name;
        if (
          !/^[a-zA-Z0-9-_]+(.{1}(jpe?g|png|pdf|JPE?G|PNG|PDF))$/.test(fileName)
        ) {
          this.setState({
            ADCR: {
              name: "",
              isError: true,
              isShowError: true,
              AED_DocImage: "",
              AED_DocType: "ADCR",
              errorMessage:
                "Invalid Filename. Filenames may only have A-Z, a-z, 0-9,' - ' and '_' ",
            },
          });
          return;
        }
        const filesize = Math.floor(file.size / 1024);
        if (filesize > 5000 || filesize < 2) {
          alert("File Size should be between 2KB and 5MB.");
          return;
        }
        this.setState({
          ADCR: {
            name: file.name,
            isError: false,
            isShowError: false,
            AED_DocImage: base64.split(",")[1],
            AED_DocName: file.name,
            AED_DocType: "ADCR",
            fileSize: `(${filesize}Kb)`,
          },
        });
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    }
  };
  AdressproofUpload = (label) => (e) => {
    if (!!e.target.files.length) {
      const file = e.target.files[0];
      var fileReader = new FileReader();
      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        base64 = fileLoadedEvent.target.result;
        const fileName = file.name;
        if (
          !/^[a-zA-Z0-9-_]+(.{1}(jpe?g|png|pdf|JPE?G|PNG|PDF))$/.test(fileName)
        ) {
          this.setState({
            ADPR: {
              name: "",
              isError: true,
              isShowError: true,
              AED_DocImage: "",
              AED_DocType: "ADPR",
              errorMessage:
                "Invalid Filename. Filenames may only have A-Z, a-z, 0-9,' - ' and '_' ",
            },
          });
          return;
        }
        const filesize = Math.floor(file.size / 1024);
        if (filesize > 5000 || filesize < 2) {
          alert("File Size should be between 2KB and 5MB. ");
          return;
        }
        this.setState({
          ADPR: {
            name: file.name,
            AED_DocImage: base64.split(",")[1],
            AED_DocName: file.name,
            AED_DocType: "ADPR",
            isError: false,
            isShowError: false,
            fileSize: `(${filesize}Kb)`,
          },
        });
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    }
  };
  CancelledChequeUpload = (label) => (e) => {
    if (!!e.target.files.length) {
      const file = e.target.files[0];
      var fileReader = new FileReader();
      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        base64 = fileLoadedEvent.target.result;
        const fileName = file.name;
        if (
          !/^[a-zA-Z0-9-_]+(.{1}(jpe?g|png|pdf|JPE?G|PNG|PDF))$/.test(fileName)
        ) {
          this.setState({
            CHQ: {
              name: "",
              isError: true,
              isShowError: true,
              AED_DocImage: "",
              AED_DocType: "CHQ",
              errorMessage:
                "Invalid Filename. Filenames may only have A-Z, a-z, 0-9,' - ' and '_' ",
            },
          });
          return;
        }
        const filesize = Math.floor(file.size / 1024);
        if (filesize > 5000 || filesize < 2) {
          alert("File Size should be between 2KB and 5MB.");
          return;
        }
        this.setState({
          CHQ: {
            name: file.name,
            AED_DocImage: base64.split(",")[1],
            AED_DocName: file.name,
            AED_DocType: "CHQ",
            isError: false,
            isShowError: false,
            fileSize: `(${filesize}Kb)`,
          },
        });
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    }
  };
  render() {
    const { Nps_Rejection_Details } = this.props;
    const { RejectionBank, RejectionMessage } = Nps_Rejection_Details;
    return (
      <div className="container-margin">
        <div className="customer-support-email">
          Customer Support Email :{" "}
          <a href="mailto:npsdistributorsupport@kfintech.com">
            npsdistributorsupport@kfintech.com
          </a>
        </div>
        {!!RejectionBank && (
          <div className="nps-rejected-message">
            {`Your application was rejected by ${RejectionBank} for the reason : ${RejectionMessage}`}
          </div>
        )}
        <div className="investor-title">Online Empanelment</div>

        <Paper className="digital-form-container">
          <div className="digital-form-Right-div">
            <div className="transaction-details">
              <div className="euin-text">PAN Card*</div>
              <UploadFile
                id="PAN"
                uploadFile={this.panUpload}
                fileType="application/pdf, image/png, image/jpeg, image/jpg"
                fileName={!!this.state.PAN.name ? this.state.PAN.name : ""}
                isShowError={this.state.PAN.isShowError}
                fileSize={this.state.PAN.fileSize}
                errorMessage={this.state.PAN.errorMessage}
              />
              <div className="euin-text">
                Only .jpg, .jpeg, .png and .pdf files are allowed. File Size
                should be between 2KB and 5MB. Filenames may only have A-Z, a-z,
                0-9,' - ' and '_'
              </div>
              <br />
              <div className="euin-text">ARN Certificate*</div>
              <UploadFile
                id="AddressCorrespondence"
                uploadFile={this.AddressCorrespondenceUpload}
                fileType="application/pdf, image/png, image/jpeg, image/jpg"
                fileName={!!this.state.ADCR.name ? this.state.ADCR.name : ""}
                isShowError={this.state.ADCR.isShowError}
                fileSize={this.state.ADCR.fileSize}
                errorMessage={this.state.ADCR.errorMessage}
              />
              <div className="euin-text">
                Only .jpg, .jpeg, .png and .pdf files are allowed. File Size
                should be between 2KB and 5MB. Filenames may only have A-Z, a-z,
                0-9,' - ' and '_'
              </div>
              <br />
              <div className="euin-text">Cancelled Cheque</div>
              <UploadFile
                id="CancelledCheque"
                uploadFile={this.CancelledChequeUpload}
                fileType="application/pdf, image/png, image/jpeg, image/jpg"
                fileName={!!this.state.CHQ.name ? this.state.CHQ.name : ""}
                isShowError={this.state.CHQ.isShowError}
                fileSize={this.state.CHQ.fileSize}
                errorMessage={this.state.CHQ.errorMessage}
              />{" "}
              <div className="euin-text">
                Only .jpg, .jpeg, .png and .pdf files are allowed. File Size
                should be between 2KB and 5MB. Filenames may only have A-Z, a-z,
                0-9,' - ' and '_'
              </div>
              <br />
              <div className="euin-text">Address Proof*</div>
              <UploadFile
                id="AddressProof"
                uploadFile={this.AdressproofUpload}
                fileType="application/pdf, image/png, image/jpeg, image/jpg"
                fileName={!!this.state.ADPR.name ? this.state.ADPR.name : ""}
                isShowError={this.state.ADPR.isShowError}
                fileSize={this.state.ADPR.fileSize}
                errorMessage={this.state.ADPR.errorMessage}
              />{" "}
              <div className="euin-text">
                Only .jpg, .jpeg, .png and .pdf files are allowed. File Size
                should be between 2KB and 5MB. Filenames may only have A-Z, a-z,
                0-9,' - ' and '_'
              </div>
              <div className="digital-form-button-next-div">
                <Signbutton
                  buttontitle="Save and Proceed"
                  onClick={this.submit}
                />
              </div>
              <div className="input-margin flex">
                <div className="appbar-div dual-margin mouse-pointer">
                  <span
                    className="input-name"
                    onClick={() =>
                      this.props.history.push(
                        NPS_URL + "/onlineEmpanelement/bankDetails"
                      )
                    }
                    style={{
                      color: "#007bff",
                      marginTop: "20px",
                    }}
                  >
                    {"Back to Bank Details page"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}
export default connect(({ npsReducer }) => {
  const { Nps_Rejection_Details } = npsReducer;
  return { Nps_Rejection_Details };
})(onlineEmpanelementupload);
